import React from "react";

import styles from "./styles";

export const Header = () => (
  <div className={styles.root}>
    <div className={styles.intro}>
      <a href="#main">
        <h1 className={styles.name}>Silvia Rebelo</h1>
        <div className={styles.title}>Senior Software Engineer</div>
      </a>
    </div>
    <ul className={styles.navigation}>
      <li>
        <a
          href="https://github.com/teknotica"
          target="_blank"
          rel="noreferrer noopener"
        >
          Github
        </a>
      </li>
      <li>
        <a
          href="https://www.linkedin.com/in/srebelo"
          target="_blank"
          rel="noreferrer noopener"
        >
          LinkedIn
        </a>
      </li>
    </ul>
  </div>
);

